import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link , useNavigate} from "react-router-dom";

const Surface = () => {

    const navigate = useNavigate();
    const [dataSurface, setDataSurface] = useState([]);

    // State variables to manage button visibility
    const [showSubmitButton, setShowSubmitButton] = useState(true);
    const [showUpdateButton, setShowUpdateButton] = useState(false);

    const [newdata, setNewdata] = useState({
        id:"", surface: "", created_by: ""
    });
    const { surface } = newdata;
    let userInfo = JSON.parse(localStorage.getItem('admin-info'));

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetSurfaceDetailsAll', setDataSurface);

    }, []);

    

    const columns = [
        {
            name: "Surface",
            selector: row => row.surface,
            sortable: true,
            width: "200px"
        },
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Link to={``} onClick={() => onStatusClick(row.id, row.style)}>
                        <img
                            src={row.status === 1 ? "/images/ImgActive.gif" : "/images/ImgInActive.gif"}
                            alt="Change Status"
                            title="Change Status"
                            style={{ width: "50px", height: "25px" }}
                        />
                    </Link>

                    {' '} {' '}{' '} {' '}{' '} {' '}{' '} {' '}
                    <Link to={``} onClick={(event) => onEditClick(event, row.id)}>
                        <img
                            src="/images/ImgEdit.ico" // Set the correct image source
                            alt="Edit"
                            title="Edit"
                            style={{ width: "30px", height: "30px" }}
                        />
                    </Link>
                </div>
            ),
            maxWidth:"200px",

        },
    ];

    const onStatusClick = async (id, surface) =>{
    
        const confirmed = window.confirm("Are you sure you want to change " +surface+ " Surface status?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {
            
            const response = await fetch('https://igapi.heuristticminds.com/api/SubjectStyleList/Update-ChangeSurfaceStatus?id=' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                
            }
        }
        catch {
        }
    };

    const onEditClick = async (event, id) => {

        event.preventDefault(); // Prevents the default behavior of the link
        try {
            // Fetch the surface details for the specific ID
            const response = await fetch(`https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetSurfaceDetailsToEditByID?id=${id}`);
            const data = await response.json();
            
            // Set the surface details in the input box for editing
            setNewdata({ id: data.id, surface: data.surface });
    
            // Toggle the visibility of submit/update buttons
            setShowSubmitButton(false);
            setShowUpdateButton(true);
        } catch (error) {
            console.error("Error fetching surface details:", error);
        }
    }

    const handleUpdate = async()=>{
    

        /* setShowSubmitButton(true);
        setShowUpdateButton(false); */

        try {
            const response = await fetch(`https://igapi.heuristticminds.com/api/SubjectStyleList/Update-UpdateSurfaceDetails`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newdata), // Send the surface ID and updated name
            });
    
            if (response.ok) {
                alert("Surface updated successfully");
                // Clear the input fields and reset button visibility
                setNewdata({ id: "", surface: "" });
                setShowSubmitButton(true);
                setShowUpdateButton(false);
    
                // Optionally, refetch the updated list of surfaces
                fetchData('https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetSurfaceDetailsAll', setDataSurface);
            } else {
                console.error("Failed to update surface");
            }
        } catch (error) {
            console.error("Error updating surface:", error);
        }
    
    }

    const handleSubmit = async()=> {

        const requestData = {
            ...newdata,
            createdBy: userInfo.user_id // Set the created_by field before submitting
        };
        try {
            const response = await fetch('https://igapi.heuristticminds.com/api/SubjectStyleList/Add-SaveSurfaceDetailList', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData), // Send new surface data
            });
    
            if (response.ok) {
                alert("Surface added successfully");
                setNewdata({ id: "", surface: "" });
                fetchData('https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetSurfaceDetailsAll', setDataSurface);
            } else {
                console.error("Failed to add surface");
            }
        } catch (error) {
            console.error("Error adding surface:", error);
        }
    }
    
    return(
        <>
             <Header />
        <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='Art Surface' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4">
                                    <div className="card-header">Artwork Surface Details</div>
                                    <div className="card-body">
                                    <div className="row">
                                                {/* <div className="col-sm-12">
                                                    <a href="/addStyles" className="btn btn-primary"><i className="bi bi-plus-circle-fill"></i> Add Styles</a>
                                                </div> */}
                                            </div>
                                            <div className="pb-2">
                                    <div className="row">
                                            
                                            <div className="col-sm-2 form-group mb-2">
                                                
                                            <input type="text"
                                                    name="surface"
                                                    value={surface}
                                                    onChange={(e) => setNewdata({ ...newdata, surface: e.target.value })} // Update the surface in state
                                                    className="form-control"
                                                    maxLength={15}
                                                    placeholder="Surface"// Set readOnly based on readOnlyFields state
                                                    />
                                            </div>
                                            <div className="col-sm-2 form-group mb-2">
                                                
                                            </div>
                                            <div className="col-sm-2 form-group mb-2">
                                                
                                                
                                            </div>
                                            
                                            <div className="col-sm-2 form-group mb-2">
                                                
                                                
                                            </div>
                                            <div className="col-sm-4 form-group mb-4">
                                            <button type="button" onClick={handleSubmit} 
                                             className={`btn btn-primary w-50 ${showSubmitButton ? '' : 'd-none'}`}>Submit</button>
                                            <button type="button" onClick={handleUpdate} className={`btn btn-primary w-50 ${showUpdateButton ? '' : 'd-none'}`}>Update</button>                                              
                                            </div>
                                            </div>
                                            
                                    </div>
                                    <div className="pb-2">
                                    
                                    <div className="col-sm-6">
                                    <DataTable 
                                                columns={columns}
                                                data={dataSurface}
                                            /> 
                                    </div>
                                    <div className="col-sm-6">
                                        
                                    </div>
   
                                    </div>
                                    </div>
                                    
                                    
                                    
                                
                            </div>

                        </div>
                    </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
};
export default Surface



